import React from 'react';
import { IntlShape } from 'react-intl';
import Text from '../../../global/text/text';
import { IAccountUsersDTO } from '../../../../api/account-users.dao';
import { DateTimeFormatter } from '../../../../infrastructure/implementations/date-formatter';
import { DateFnsFormats, TimeFormats } from '../../../../infrastructure/date-formatter';
import classnames from 'classnames';
import * as IoC from 'typescript-ioc';


interface IProps extends IAccountUsersDTO {
    intl: IntlShape;
}

const AccountUsersListItem = (props: IProps) => {
    const {
        firstName,
        lastName,
        email,
        roles,
        isActive,
        insertAt,
        lastLoginAt,
        intl
    } = props;

    const rolesColumnText = roles.length
        ? roles.map(role => role.name).join(', ')
        : intl.formatMessage({
            id: 'oe.role.none',
            description: 'Label text',
            defaultMessage: 'None'
        });
    const status = isActive
        ? intl.formatMessage({
            id: 'oe.common.active',
            description: 'Label text',
            defaultMessage: 'Active'
        })
        : intl.formatMessage({
            id: 'oe.common.inactive',
            description: 'Label text',
            defaultMessage: 'Inactive'
        });

        const dateTimeFormatter = IoC.Container.get<DateTimeFormatter>(DateTimeFormatter);

    const formatDateTime = (date: string): { date: string; time: string } => {
        if (!date) return { date: '', time: '' };
        const dateObj = new Date(date);
        const formattedDate = dateTimeFormatter.dateToFormattedString(dateObj, DateFnsFormats.ShortDayMonthYear24Hours);
        const formattedTime = dateTimeFormatter.dateToFormattedString(dateObj, TimeFormats.Day24Hours);
        return {
            date: formattedDate,
            time: formattedTime
        };
    };

    const { date: formattedCreatedDate, time: formattedCreatedTime } = formatDateTime(insertAt);
    const { date: formattedLastLoginDate, time: formattedLastLoginTime } = formatDateTime(lastLoginAt);

    return (
        <tr className={classnames('role-item', {'user-item__not-active': !isActive})}>
            <td>
                <div className='role-item__column role-item__name'>
                    <div className='role-item__name-content'>
                        <Text className='role-item__text' message={firstName} withEllipsis />
                    </div>
                </div>
            </td>
            <td>
                <div className='role-item__column role-item__description'>
                    <div className='role-item__description-content'>
                        <Text className='role-item__text' message={lastName} withEllipsis/>
                    </div>
                </div>
            </td>
            <td>
                <div className='role-item__column role-item__description'>
                    <div className='role-item__description-content'>
                        <Text className='role-item__text' message={email} withEllipsis/>
                    </div>
                </div>
            </td>
            <td>
                <div className='user-item__column'>
                    <Text
                        className='user-item__text'
                        message={rolesColumnText}
                        withEllipsis
                        withHighlight
                    />
                </div>
            </td>
            <td>
                <div className='user-item__column'>
                    <Text
                        className='user-item__text'
                        message={status}
                        withEllipsis
                        withHighlight
                    />
                </div>
            </td>
            <td>
                <p>{formattedCreatedDate}</p>
                <p>{formattedCreatedTime}</p>
            </td>
            <td>
                <p>{formattedLastLoginDate}</p>
                <p>{formattedLastLoginTime}</p>
            </td>
        </tr>
    );
};

export { AccountUsersListItem };